import { FormField, Button, SpinnerCircular, Notification } from '@weirgroup/weir-dls'
import assetsApi from '../../../api/assets.api'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { BucketDataType } from '../../../types/bucketTypes'
import { useTranslation } from 'react-i18next'
import { StorageService } from '../../../services/storage_service'
import { ToastDataType } from '../../../types/toast.type'
import { isValidEmail } from '../../../utils/email.util'
import { useDarkMode } from '../../../hooks/use-darkmode'

interface Props {
    isGuest: boolean
    setIsModalShown: Dispatch<SetStateAction<any>>
    fetchBucketList: (arg?: boolean) => Promise<void>
    selectedAsset: BucketDataType
    triggerToastMessage: (arg1: boolean, arg2: any) => void
}

export const Transfer = (props: Props) => {
    const {
        isGuest,
        setIsModalShown,
        fetchBucketList,
        selectedAsset,
        triggerToastMessage,
    } = props

    const userData = StorageService.getItem('userData')
    const userEmail = userData ? JSON.parse(userData).email : ''

    const [email, setEmail] = useState<string>('')
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [showToast, setShowToast] = useState<boolean>(false)
    const [toastData, setToastData] = useState<any>()
    const [isEmailValid, setIsEmailValid] = useState<boolean>(true)
    const {darkMode} = useDarkMode();
    const { t } = useTranslation()

    useEffect(() => {
        if (showToast) {
            setTimeout(() => setShowToast(false), 5000)
        }
    }, [toastData])

    const handleEmailChange = (e: any) => {
        const emailValue = e.target.value
        setEmail(emailValue)
        setIsEmailValid(isValidEmail(emailValue))
    }

    const transfer = async () => {
        if (email === userEmail || !isValidEmail(email)) {
            showErrorMessage(
                !isValidEmail(email)
                    ? t('transferInvalidEmail')
                    : t('transferSameEmailErrorMsg')
            )
        } else {
            setIsLoading(true)
            assetsApi
                .transferAsset(selectedAsset.asset_id, email)
                .then(async (res) => {
                    let resource = {
                        data:`Successfully transferred asset to a ${email}`,
                        response:{
                            data:{
                                message:`Successfully transferred asset to group ${email}`
                            }
                        }
                    }
                    setIsLoading(false)
                    //show success toast
                    triggerToastMessage(true, resource)
                    //close modal
                    setIsModalShown(false)
                    //trigger refetch of assets
                    fetchBucketList(false)
                })
                .catch((err) => {
                    setIsLoading(false)
                    showErrorMessage(
                        err.response.data.message || t('transferFail')
                    )
                })
        }
    }

    const showErrorMessage = (message: string) => {
        const toastData: ToastDataType = {
            message,
            variant: 'critical',
        }
        setShowToast(true)
        setToastData(toastData)
    }

    return (
        <div className="transfer" data-testid="transfer">
            <p className="title" style={{color:darkMode ? "white" : "gray"}}>{t('transferTitle')}</p>
            <FormField
                darkMode={darkMode}
                name="InputBox"
                label={t('transferRecipient')}
                size={'sm'}
                width={'100%'}
                placeholder={t('enterEmail')}
                onChange={handleEmailChange}
                autoComplete="off"
                required={true}
                disabled={isGuest}
                error={!isEmailValid && email !== ''}
                errorMessage={!isEmailValid && email !== '' ? t('transferInvalidEmail') : ''}
            />
            <div className="transfer-btn" data-testid="transfer-btn">
                <Button
                    darkMode={darkMode}
                    label={'Transfer'}
                    size={'sm'}
                    variant={'primary'}
                    disabled={isGuest || !isEmailValid || email === ''}
                    onClick={() => transfer()}
                />
            </div>
            {isLoading ? (
                <div className="spinner">
                    <SpinnerCircular darkMode={darkMode} />
                    <p style={{color:darkMode ? "white" : "black"}}>{t('loading')}</p>
                </div>
            ) : (
                <></>
            )}
            {showToast ? (
                <div className="toast-container">
                    <Notification 
                        darkMode={darkMode}
                        title={toastData.variant == "success" ? "Success" : "Fail"}
                        textContent={toastData.message}
                        variant={toastData.variant}
                        onClose={()=>{setShowToast(false)}}
                    />
                </div>
            ) : (
                <></>
            )}
        </div>
    )
}